import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../base-api.service';
import {ShiftsModelService} from '../../Models/Core/shifts-model.service';

@Injectable({
  providedIn: 'root'
})
export class ShiftsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: ShiftsModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener los turnos
   *
   */
  public getShifts(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getTurnos', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err) => {
          reject(err)
        }
      });

    });

  }

}
